import {
	CalendarDays,
	Hash,
	CheckSquare,
	FileText,
	List as ListIcon,
	User,
	type LucideIcon
} from 'lucide-react';
import { type DataType, type FieldDefinition } from '@/types';
import {
	renderDateNatural,
	renderDateRelative,
	renderBadge,
	renderBoolean,
	renderNumber,
	renderText,
	renderSystemUser
} from './renderFunctions';

export interface FieldTypeRenderer {
	icon: LucideIcon;
	render: (value: any, record?: any) => React.ReactNode;
	placeholder?: string;
}

export const FIELD_TYPE_RENDERERS: Record<DataType, FieldTypeRenderer> = {
	date: {
		icon: CalendarDays,
		render: renderDateNatural,
		placeholder: 'Select date...'
	},
	select: {
		icon: ListIcon,
		render: renderBadge
	},
	number: {
		icon: Hash,
		render: renderNumber
	},
	text: {
		icon: FileText,
		render: renderText,
		placeholder: 'Enter text...'
	},
	checkbox: {
		icon: CheckSquare,
		render: renderBoolean
	},
	boolean: {
		icon: CheckSquare,
		render: renderBoolean
	},
	'ai prompt': {
		icon: FileText,
		render: renderText,
		placeholder: 'AI will generate...'
	},
	systemUserSelect: {
		icon: User,
		render: renderSystemUser,
		placeholder: 'Select user...'
	}
};

export const FIELD_OVERRIDES: Record<string, Partial<FieldDefinition>> = {
};
